import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import ForbiddenState from '@rio-cloud/rio-uikit/ForbiddenState';

import { t } from '@/lib/utils';

const NoPermissionsPage = () => (
    <ApplicationLayout.Body>
        <ForbiddenState
            headline={t('general.noPermissions.headline')}
            message={t('general.noPermissions.message')}
            buttons={[
                {
                    text: t('general.noPermissions.button'),
                    onClick: () => {
                        window.location.href = 'https://rio.cloud/en/marketplace/man-digital-services';
                    },
                },
            ]}
        />
    </ApplicationLayout.Body>
);

export default NoPermissionsPage;
